import React from 'react';

const formatCurrencyValue = (value) => {
  if (value === '' || value === null || value === undefined) return '';

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return '';

  return numericValue.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

const CurrencyInput = ({
  value,
  onValueChange,
  required = false,
  disabled = false,
  className = '',
  id,
  name,
  autoFocus = false
}) => {
  const handleChange = (event) => {
    const digits = event.target.value.replace(/\D/g, '');

    if (!digits) {
      onValueChange('');
      return;
    }

    const normalizedValue = (Number(digits) / 100).toFixed(2);
    onValueChange(normalizedValue);
  };

  return (
    <div className={`relative ${className}`}>
      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500 pointer-events-none">
        R$
      </span>
      <input
        id={id}
        name={name}
        type="text"
        inputMode="numeric"
        autoComplete="off"
        value={formatCurrencyValue(value)}
        onChange={handleChange}
        placeholder="0,00"
        required={required}
        disabled={disabled}
        autoFocus={autoFocus}
        className="w-full border border-gray-300 rounded-lg py-2 pl-10 pr-3 text-right disabled:bg-gray-100 disabled:text-gray-500"
      />
    </div>
  );
};

export default CurrencyInput;
